import React from "react";
import {
  Button,
  Card,
  CardBody,
  Col,
  FormGroup,
  Input,
  Label,
  Row,
} from "reactstrap";
import { DatePicker } from "antd";
import moment from "moment";
import { Link } from "react-router-dom";

const ManageUserContent = ({
  searchBy,
  setSearchByValue,
  setFromDate,
  setSearchBy,
  searchByValuePlaceholder,
  searchByValue,
  fromDate,
  handleFIlter,

  setModalShow,
  filtersSelected,
  noOfFiltersSelected,
  resetFilter,
  handleChangeFilter,
}) => {
  const dateFormat = "DD-MM-YY";
  const customFormat = (value) => `${value.format(dateFormat)}`;
  return (
    <>
      <Card>
        <CardBody>
          <Row>
            <Col lg="3" className="form-input-padding">
              <FormGroup>
                <label
                  className="form-control-label"
                  htmlFor="exampleFormControlSelect1"
                >
                  Search by
                </label>
                <Input
                  id="exampleFormControlSelect1"
                  type="select"
                  style={{ height: "27px" }}
                  value={searchBy}
                  onChange={(e) => {
                    setSearchByValue("");
                    setSearchBy(e.target.value);
                  }}
                >
                  <option value="userName">User Name</option>
                  <option value="email"> Email</option>
                </Input>
              </FormGroup>
            </Col>
            <Col lg="3" className="form-input-padding">
              <FormGroup>
                <label
                  className="form-control-label"
                  htmlFor="example3cols2Input"
                >
                  Search for
                </label>
                <Input
                  id="example3cols2Input"
                  placeholder={searchByValuePlaceholder}
                  type="text"
                  style={{ height: "27px" }}
                  onKeyPress={(e) => handleChangeFilter(true, e)}
                  onChange={(e) => {
                    setSearchByValue(e.target.value && e.target.value.trim());
                  }}
                  value={searchByValue}
                />
              </FormGroup>
            </Col>
            <Col lg="2">
              <FormGroup>
                <Label
                  className="form-control-label"
                  htmlFor="example3cols2Input"
                >
                  Date
                </Label>
                <DatePicker
                  format={customFormat}
                  placeholder="DD-MM-YY"
                  className="formcontrol-date"
                  onChange={(e, dateString) => {
                    if (dateString && dateString != "") {
                      setFromDate(moment(dateString, dateFormat));
                    } else {
                      setFromDate(null);
                    }
                  }}
                  value={fromDate}
                  // format={dateFormat}
                />
              </FormGroup>
            </Col>
            {/* <div lg="1" className="form-input-padding">
              <FormGroup>
                <Label
                  className="form-control-label"
                  htmlFor="exampleFormControlSelect1"
                >
                  Filter by
                </Label>
                <div>
                  <Button
                    style={{ width: "100%", height: "26px" }}
                    color="primary"
                    type="button"
                   id="example3cols2Input"
                    className="filter-button"
                    onClick={() => setModalShow(true)}
                  >
                    <div>
                      {" "}
                      <i className="fas fa-filter"></i>
                    </div>
                  </Button>
                </div>
              </FormGroup>
              <span style={{ fontSize: 8 }}>
                {filtersSelected ? (
                  <>
                    <h6 style={{ display: "flex", alignItems: "center" }}>
                      Selected({noOfFiltersSelected}){" "}
                      <i
                        class="fas fa-window-close"
                        onClick={() => resetFilter()}
                        style={{ cursor: "pointer", paddingLeft: "5px" }}
                      />
                    </h6>
                  </>
                ) : (
                  <></>
                )}
              </span>
            </div>  */}
            <Col
              lg="1"
              style={{ marginTop: "9px" }}
              className="form-input-padding"
            >
              <FormGroup>
                <Label
                  className="form-control-label"
                  htmlFor="example3cols2Input"
                ></Label>
                <div>
                  <Button
                    type="button"
                    style={{
                      width: "100%",
                      background: "#e91d24",
                      color: "white",
                      height: "26px",
                      border: "1px solid rgb(233, 29, 36)",
                    }}
                    id="example3cols2Input"
                    className="filter-button"
                    onClick={() => handleFIlter(true)}
                  >
                    <div>
                      <i class="fas fa-search"></i>
                    </div>
                  </Button>
                </div>
              </FormGroup>
            </Col>
            <Col
              lg="1"
              style={{ marginTop: "9px", padding: "0px 6px" }}
              className="form-input-padding"
            >
              <FormGroup>
                <Label
                  className="form-input-padding col-lg-1"
                  htmlFor="example3cols2Input"
                ></Label>
                <div>
                  <Button
                    color="light"
                    type="button"
                    style={{ width: "100%", height: "26px" }}
                    id="example3cols2Input"
                    className="filter-button"
                    onClick={() => resetFilter()}
                  >
                    <div
                      style={{
                        fontSize: "12px",
                      }}
                    >
                      <i class="fas fa-redo-alt 2px"></i> Reset
                    </div>
                  </Button>
                </div>
              </FormGroup>
            </Col>

            <Col
              lg="1"
              style={{ marginTop: "8px" }}
              className="form-input-padding"
            >
              <FormGroup>
                <Label
                  className="form-control-label"
                  htmlFor="example3cols2Input"
                ></Label>
                <div>
                  <Link
                    style={{ color: "black" }}
                    to={{
                      pathname: "/admin/create-new-user",
                    }}
                  >
                    <Button
                      color="primary"
                      type="button"
                      style={{ height: "26px" }}
                      id="example3cols2Input"
                    >
                      <div
                        style={{
                          fontSize: "12px",
                        }}
                      >
                        Create New User
                      </div>
                    </Button>
                  </Link>
                </div>
              </FormGroup>
            </Col>
          </Row>
        </CardBody>
      </Card>
    </>
  );
};

export default ManageUserContent;
